import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Header from "../../../component/organisms/header";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import Sidebar from "../../../component/organisms/sidebar";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import DetailTop from "../../../component/atoms/layout/detail/detailTop";
import GoBack from "../../../component/molecules/goBack";
import DelBtn from "../../../component/atoms/button/delBtn";
import DetailPageTitle from "../../../component/atoms/text/detail/detailPageTitle";
import DetailPageForm from "../../../component/atoms/layout/detail/detailPageForm";
import DetailFormTitle from "../../../component/atoms/text/detail/detailFormTitle";
import DetailFormText from "../../../component/atoms/text/detail/detailFormText";
import DetailPage from "../../../component/atoms/layout/detail/detailPage";
import { errorHandler } from "../../../util/errorHandler";
import { toast } from "react-toastify";
import { toastMsg } from "../../../util/toastMsg";
import moment from "moment";
import Modal from "../../../component/templates/Modal";
import { modalMsg } from "../../../util/modalMsg";
import CommunityApi from "../../../api/community.api";
import { homeUrl } from "../../../constants/url";

const CommentReportDetail = () => {
  const navigate = useNavigate();
  let { id } = useParams();

  const [commentType, setCommentType] = useState("column");
  const [postId, setPostId] = useState(-1);

  // mounted
  useEffect(() => {
    getReportInfo();
  }, []);

  // ----- 정보 가져오기
  const [reportInfo, setReportInfo] = useState({
    title: "",
    content: "",
    email: "",
    createdAt: "",
  });

  const getReportInfo = async () => {
    try {
      const response = (await CommunityApi.getReportById(id)).data.data.content;

      setReportInfo(response);

      if (response.communityComment.columnPostId) {
        setCommentType("column");
        setPostId(response.communityComment.columnPostId);
        return;
      }

      if (response.communityComment.communityPostId) {
        setCommentType("community");
        setPostId(response.communityComment.communityPostId);
        return;
      }
    } catch (error) {
      errorHandler(error);
    }
  };

  // ----- 삭제
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const deleteFunc = async () => {
    try {
      await CommunityApi.delReport(id);
      toast(toastMsg.delete);
      setDeleteModalOpen(false);
      navigate(-1);
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout>
        <Sidebar />
        <DetailPageLayout>
          <DetailTop>
            <GoBack />
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <DelBtn onClick={() => setDeleteModalOpen(true)} />
            </div>
          </DetailTop>

          <DetailPage>
            <DetailPageTitle>상세보기</DetailPageTitle>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "20px" }}
            >
              <DetailPageForm>
                <DetailFormTitle>게시자 아이디</DetailFormTitle>
                <DetailFormText>
                  {reportInfo.communityComment?.member?.account}
                </DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>게시자 닉네임</DetailFormTitle>
                <DetailFormText>
                  {reportInfo.communityComment?.member?.nickname}
                </DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>작성일</DetailFormTitle>
                <DetailFormText>
                  {moment
                    .utc(reportInfo?.communityComment?.createdAt)
                    .format("YYYY/MM/DD")}
                </DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>신고 댓글</DetailFormTitle>
                <DetailFormText
                  onClick={() => {
                    window.open(
                      homeUrl +
                        `/finlive/${
                          commentType === "column" ? "column" : "community"
                        }/detail/${postId}`,
                      "_blank"
                    );
                  }}
                  style={{ textDecorationLine: "underline", cursor: "pointer" }}
                >
                  미리보기
                </DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>신고 댓글 내용</DetailFormTitle>
                <DetailFormText>
                  {reportInfo.communityComment?.content}
                </DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>신고일자</DetailFormTitle>
                <DetailFormText>
                  {moment.utc(reportInfo.createdAt).format("YYYY/MM/DD")}
                </DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>신고자 아이디</DetailFormTitle>
                <DetailFormText>{reportInfo.reporter?.account}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>신고자 닉네임</DetailFormTitle>
                <DetailFormText>{reportInfo.reporter?.nickname}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>신고사유</DetailFormTitle>
                <DetailFormText>{reportInfo?.reason}</DetailFormText>
              </DetailPageForm>
            </div>
          </DetailPage>
        </DetailPageLayout>
      </MainLayout>

      {deleteModalOpen ? (
        <Modal
          negative
          title={modalMsg.delete?.title}
          text={modalMsg.delete?.content}
          btnTitle={"삭제하기"}
          setModalOpen={setDeleteModalOpen}
          onClick={() => {
            deleteFunc();
          }}
        />
      ) : null}
    </>
  );
};

export default CommentReportDetail;
